import React from 'react';

const MapMarker = () => {
  return (
    <div className="mapMarkerWrapper">
      <div className="pulsating-circle" />
    </div>  
  )
}
 
export default MapMarker;



// WEBPACK FOOTER //
// ./src/components/FlightMap/MapMarker/MapMarker.jsx